import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  const cp2_ctnm = ['United States', 'France', 'Germany', 'Canada', 'Finland', 'Switzerland', 'Netherlands', 'Italy', 'Czech Republic', 'Belgium', 'United Kingdom', 'Slovakia', 'Norway', 'New Zealand', 'Lithuania', 'Croatia', 'Australia', 'Austria'];
  const cp2_data = [
    [45, 104, 13, 22, 6, 29, 21, 30, 25, 87, 61, 103, 31, 39, 145, 46, 32, 79, 131, 561, 122, 159],
    [0, 0, 0, 14, 27, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, '592†', 0, 0, 35, 0],
    [0, 27, 0, 0, 17, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 13, 0, 0, 0],
    [0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11, 25, 4, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 11, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 10],
    [0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 9],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 131, 0, 0, '4†', 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 100],
    [10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0],
  ];
  const cp2_r = document.getElementById('cpg2-roll');
  const cp2_rM = document.getElementById('cpg2-rollM');
  for (let x = 0; x <= 17; x++) {
    for (let y = 0; y <= 21; y++) {
      const adj = (x == 0) ? 90 : 135;
      const adj2 = (x == 0) ? 62 : 92;
      if (cp2_data[x][y]) {
        cp2_r.innerHTML += `<circle r="${(x == 0) ? 18 : ((x == 1) && (y == 17)) ? 30 : 14}" cx="${132.79 + (36.05 * y)}" cy="${adj + ((x) * 25)}" data-x="${x}" data-y="${y}"/>`;
        cp2_rM.innerHTML += `<circle r="${(x == 0) ? 8 : ((x == 1) && (y == 17)) ? 20 : 8}" cx="${56 + (14.15 * y)}" cy="${adj2 + ((x) * 22.85)}" data-x="${x}" data-y="${y}"/>`;
      }
    }
  }

  function gn2mrk(th, e, t) {
    const ppb = document.getElementById('popcp2');
    document.getElementById('ct2pt1').innerHTML = cp2_ctnm[th.getAttribute('data-x')];
    document.getElementById('ct2pt2').innerHTML = parseInt(th.getAttribute('data-y')) + 1998;
    document.getElementById('ct2pt3').innerHTML = cp2_data[th.getAttribute('data-x')][th.getAttribute('data-y')];
    if (t === true) {
      ppb.style.top = `${e.touches[0].clientY - th.parentElement.getBoundingClientRect().top}px`;
      if (th.getAttribute('data-y') > 10) {
        ppb.style.left = `${e.touches[0].clientX - th.parentElement.getBoundingClientRect().left - ppb.getBoundingClientRect().width + 20}px`;
      } else {
        ppb.style.left = `${e.touches[0].clientX - th.parentElement.getBoundingClientRect().left + 10}px`;
      }
    } else {
      ppb.style.top = `${e.offsetY}px`;
      ppb.style.left = `${e.offsetX}px`;
    }
    const isR = (e.offsetX > document.getElementById('gunsGP2').getBoundingClientRect().width / 2);
    ppb.classList.toggle('rts', isR);
    ppb.classList.toggle('lts', !isR);
  }

  document.querySelectorAll('#cpg2-roll>circle').forEach((a, b) => {
    a.addEventListener('mousemove', function (e) {
      gn2mrk(this, e, false);
    });
    a.addEventListener('mouseleave', function (e) {
      document.getElementById('popcp2').classList.remove('inV');
      document.getElementById(`cc${this.getAttribute('data-x')}_${this.getAttribute('data-y')}`).classList.remove('inV');
    });
    a.addEventListener('mouseenter', function (e) {
      document.getElementById('popcp2').classList.toggle('inV', (cp2_data[this.getAttribute('data-x')][this.getAttribute('data-y')] != 0));
      console.log(`cc${this.getAttribute('data-x')}_${this.getAttribute('data-y')}`);
      document.getElementById(`cc${this.getAttribute('data-x')}_${this.getAttribute('data-y')}`).classList.add('inV');
    });
  });


  document.querySelectorAll('#cpg2-rollM>circle').forEach((a, b) => {
    a.addEventListener('touchstart', function (e) {
      e.preventDefault();
      document.getElementById('popcp2').classList.toggle('inV', (cp2_data[this.getAttribute('data-x')][this.getAttribute('data-y')] != 0));
      gn2mrk(this, e, true);
    });
  });
}
